import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TELEMATIC_CHART_DATA]: {
		url: '/company/:companyId/maps/chart_data/:machineId/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_CROPS]: {
		url: '/company/:companyId/maps/crops/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_CROPS_EXTENDED_INFO]: {
		url: '/company/:companyId/maps/crops/extended_info/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_EVENTS]: {
		url: '/company/:companyId/maps/events/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_MOVEMENT_POINTS]: {
		url: '/company/:companyId/maps/movement_points/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS]: {
		url: '/company/:companyId/maps/tracks/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS_EXTENDED_INFO]: {
		url: '/company/:companyId/maps/tracks/extended_info/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS_MOVED_MACHINES]: {
		url: '/company/:companyId/maps/tracks/moved_machines/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS_REALTIME_DATA]: {
		url: '/company/:companyId/maps/tracks/realtime_data/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_FIELD_WORKS]: {
		url: '/company/:companyId/maps/field_works/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_LOGISTIC_WORKS]: {
		url: '/company/:companyId/maps/logistic_works/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_PREVIEW]: {
		url: '/company/:companyId/maps/preview/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_TRACK]: {
		url: '/company/:companyId/maps/machine_track/:machineId/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_RELATED_FIELD_WORKS]: {
		url: '/company/:companyId/maps/related_field_works/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_WIDE_TRACK]: {
		url: '/company/:companyId/maps/machine_wide_track/:machineId/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_WIDE_TRACK_CROSSED_CROPS]: {
		url: '/company/:companyId/maps/machine_wide_track/:machineId/crossed_crops/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_TRACK_POINTS]: {
		url: '/company/:companyId/maps/machine_track_points/:machineId/',
	},

	[ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGE_DATES]: {
		url: '/company/:companyId/maps/satellites/dates/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGE_DATE_DYNAMIC]: {
		url: '/company/:companyId/maps/satellites/dates/last_dynamic/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGES]: {
		url: '/company/:companyId/maps/satellites/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGE]: {
		url: '/company/:companyId/maps/satellites/:satelliteImageId/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGES_STATS]: {
		url: '/company/:companyId/maps/satellites/satellites_stats/',
	},
	[ModulesConfigMap[ModulesMap.MAPS].GET_DONE_WORK_GEOMETRIES]: {
		url: '/company/:companyId/maps/done_work_geometries/:doneWorkId/',
	},
}
